export default __webpack_public_path__ + "static/media/icons-switch-account.1fae03bf.svg";